/**
 *  @class
 *  @function VariantMappingButton
 */
if (!customElements.get('variant-mapping-button')) {
  class VariantMappingButton extends HTMLElement {
    constructor() {
        super();

        this.formData = {};
        this.clickEvent = new Event('click');

        this.mappingData = JSON.parse(document.getElementById('variantMapping').textContent);
        if(!this.mappingData) return;

        this.addToCartButton = this.closest('.add_to_cart_holder').querySelector('#AddToCart');
    }


    connectedCallback() {      
      	this.formData = {};  
        document.addEventListener("product:variant-change", (event) => {
            this.onVariantChange(event);
        });
        this.addEventListener('click', this.onClickHandler.bind(this));
    }


    onVariantChange(event) {
        this.selectedVariant = this.mappingData.variants.find(variant => variant.variant_id == event.detail.variant.id);
        if(!this.selectedVariant) return;
        
        let variantIds = this.selectedVariant.variant_mapping;
        if(variantIds.length > 0) {
            this.dataset.variantIds = variantIds.join(',');
            this.dataset.currentVariant = event.detail.variant.id;            
            this.classList.remove('is-hidden');
            this.addToCartButton.classList.add('is-hidden');
        } else {
            this.classList.add('is-hidden');
            this.addToCartButton.classList.remove('is-hidden');
        }
    }


    onClickHandler(event) {
      event.preventDefault();
      //event.stopPropagation();
        if(!this.dataset.variantIds.length > 0) return;        

        let allVariantIds = [],
            metafieldIds = [];			      

        //SHOW LOADING
        if (this.classList.contains('loading')) return;
        this.setAttribute('aria-disabled', true);
        this.classList.add('loading');

        this.idsArray = this.dataset.variantIds.split(',');
        this.idsArray.forEach((id, index) => {
            metafieldIds.push({id: id, quantity: parseInt(this.closest('.add_to_cart_holder').querySelector('[name="quantity"]').value)});
        });

        if(!metafieldIds) console.log("Variant mapping metafields not deteced.");

        let easifyVariantIds = this.getEasifyAddonsVariantIds();

        this.formData['items'] = metafieldIds.concat(easifyVariantIds);
        this.formData['sections'] = this.getSectionsToRender().map((section) => section.section);
        this.formData['sections_url'] = window.location.pathname;

        this.addItemToCart(this.formData);
        event.stopImmediatePropagation();
    }


    getEasifyAddonsVariantIds() {
        const productInfo = document.querySelector('.product-information');
        
        if(!productInfo.querySelector('.tpo_option-set-container')) return;
        
        const easifyAddonsBlock = productInfo.querySelector('.tpo_option-set-container');
        const easifyAddonInputs = easifyAddonsBlock.querySelectorAll('.tpo-checkbox-button[data-checked="true"]');
        const addonsVariantIds = [];

        if(!easifyAddonInputs) {
            console.log("No easify addons inputs");
            return;
        }

        easifyAddonInputs.forEach((checkbox, index) => {
            let radioButtonWrapper = checkbox.closest('.tpo_radio-button-wrapper');

            let qty = 1
            if(radioButtonWrapper.querySelector('.tpo_quantity-selector_wrapper input')) {
              let qtyShadowHost = radioButtonWrapper.querySelector('.tpo_quantity-selector_wrapper input');
              qty = qtyShadowHost.value || 1;
            }
            addonsVariantIds.push({id: checkbox.dataset.variantId, quantity: parseInt(qty)});
        });
        
        return addonsVariantIds;
    }


    addItemToCart(item) {
        fetch(theme.routes.cart_add_url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(item)
        })
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
                dispatchCustomEvent('product:variant-error', {
                    source: 'product-form',
                    productVariantId: item['id'],
                    errors: response.description,
                    message: response.message
                });
                if (response.status === 422) {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true
                    }));
                }
                this.handleErrorMessage(response.description);
                return;
            }
            
            this.renderContents(response);
            
            dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
            });
        })
        .catch((e) => {
            console.error("Variant mapping", e);
        })
        .finally(() => {
            if (!this.classList.contains('loading')) return;
            this.setAttribute('aria-disabled', false);
            this.classList.remove('loading');
        });
    }    


    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }


    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          document.getElementById('Cart-Drawer').open();
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }
    }


    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }


    handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        }
    }    
  }
  customElements.define('variant-mapping-button', VariantMappingButton);
}


var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

